module.exports = __webpack_public_path__ + "img/frog.5d017fcb.svg";